<template>
  <div class="page-table musteriTanim  mainDiv mb-30" id="affix-container">
    <div class="animated fadeInUp card-base baslikBg">
      Yatırımcı Tanımla
    </div>

    <el-row :gutter="10" v-loading="loading" :element-loading-text='$t("src.views.apps.yatirimci.tanimlama.addLoading")'
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-form status-icon :model="musteriForm" :rules="rulesMusteri" ref="musteriForm" class="demo-ruleForm">
        <el-col :lg="18" :md="18" :sm="24" :xs="24">
          <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft pb-20 pt-10">
            <el-row>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Firma Adı" prop="musteriAdi">
                  <el-input size="small" auto-complete="off" v-model="musteriForm.musteriAdi"
                            :placeholder="'Firma Adı Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Firma Unvanı" prop="unvan">
                  <el-input size="small" auto-complete="off" v-model="musteriForm.unvan"
                            :placeholder="'Firma Unvanı Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Telefon" prop="telefon">
                  <el-input size="small" auto-complete="off" v-mask="'+90(###)### ## ##'"
                            v-model="musteriForm.telefon" :placeholder="'Telefon Numarası Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="E-posta" prop="eposta">
                  <el-input size="small" auto-complete="off" v-model="musteriForm.eposta"
                            :placeholder="'E-posta Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Vergi Dairesi" prop="vergiDairesi">
                  <el-input size="small" auto-complete="off" v-model="musteriForm.vergiDairesi"
                            :placeholder="'Vergi Dairesi Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Vergi Numarası" prop="vergiNo">
                  <el-input size="small" auto-complete="off" v-model="musteriForm.vergiNo"
                            v-mask="'##########################'"
                            :placeholder="'Vergi Numarası Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="İnternet Adresi" prop="website">
                  <el-input size="small" auto-complete="off" v-model="musteriForm.website"
                            :placeholder="'İnternet Adresi Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Adres" prop="adres">
                  <el-input type="textarea" auto-complete="off" :autosize="{ minRows: 2, maxRows: 4 }"
                            placeholder="Adres Giriniz" v-model="musteriForm.adres">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Not" prop="not">
                  <el-input type="textarea" auto-complete="off" :autosize="{ minRows: 2 }"
                            placeholder="Not" v-model="musteriForm.not">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item>
                  <el-checkbox v-model="secili">Daha Fazla Veri Eklensin mi?</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
              <el-collapse-item :title="'Ek Bilgiler'" name="2" v-if="secili">
                <template>
                  <div v-for="(ekstra, index) in ekstralar" :key="index">
                    <el-row class="mb-15">
                      <el-col :lg="5" :md="5" :sm="5" :xs="5" class="col-p">
                        <el-form-item label='Ad Soyad' prop="adSoyad">
                          <el-input v-model="ekstra.adSoyad"
                                    placeholder='Ad Soyad Giriniz'></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="5" :md="5" :sm="5" :xs="5" class="col-p">
                        <el-form-item label='Telefon Numarası' prop="telefon">
                          <el-input v-mask="'+90(###)### ## ##'" v-model="ekstra.telefon"
                                    placeholder='Telefon Numarası Giriniz'></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="5" :md="5" :sm="5" :xs="5" class="col-p">
                        <el-form-item label='E-posta' prop="eposta">
                          <el-input v-model="ekstra.eposta"
                                    placeholder='E-posta Giriniz'></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="5" :md="5" :sm="5" :xs="5" class="col-p">
                        <el-form-item label='Unvan' prop="unvan">
                          <el-input v-model="ekstra.unvan" placeholder='Unvan Giriniz'></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="2" :md="2" :sm="2" :xs="2" class="col-p">
                        <el-form-item label="Ekle" prop="ekle">
                          <el-button size="medium" type="primary"
                                     @click="addNewInfo">+
                          </el-button>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="2" :md="2" :sm="2" :xs="2" class="col-p">
                        <el-form-item label="Çıkar" prop="cikar">
                          <el-button size="medium" type="primary"
                                     @click="subInfo(index)">-
                          </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
        <el-col :lg="6" :md="6" :sm="24" :xs="24">
          <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
            <el-collapse-item class="card-shadow--medium" name="8" :title='$t("src.views.apps.genel.durum")'>
              <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                  <el-form-item prop="durum">
                    <el-select size="small" v-model="musteriForm.durum"
                               :placeholder='$t("src.views.apps.messages.addBultenTitle")' style="width: 100%">
                      <!--                                            <el-option value="0"-->
                      <!--                                                :label='$t("src.views.apps.durum.yatirimci.onay")'></el-option>-->
                      <el-option value="1" label='Aktif'></el-option>
                      <el-option value="0" label='Pasif'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-button size="mini" v-on:click="musteriEkle('musteriForm', musteriForm.durum)"
                           class="onayBtn" type="primary">
                  <label>Kaydet</label>
                </el-button>
                &nbsp;
                <el-popover placement="bottom" width="310" v-model="visibleSil">
                  <p>{{ $t('src.views.apps.messages.clearFormAlert') }}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="primary" @click="resetForm('musteriForm')">
                      {{ $t('src.views.apps.genel.yes') }}
                    </el-button>
                    <el-button size="mini" @click="visibleSil = false;">
                      {{ $t('src.views.apps.genel.no') }}
                    </el-button>
                  </div>
                  <el-button size="mini" slot="reference">
                    {{ $t('src.views.apps.genel.temizle') }}
                  </el-button>
                </el-popover>
              </el-row>
            </el-collapse-item>
            <el-collapse-item class="card-shadow--medium" name="10" title='Resim'>
              <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="padding-bottom: 30px;">
                  <Resim clearImageToSend="clearImageToSend" functionName="onPersonalImage"
                         :imageList="selectedImages"
                         :selectedsFromServer="selectedImages" :logo="true">
                  </Resim>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
import musteriService from '../../../WSProvider/MusteriService'
import notification from '../../../notification'
import functions from '../../../functions'
import EventBus from '@/components/event-bus'
import Resim from '@/components/Resim.vue'
import Seo from '@/components/Seo.vue'
import Konumlar from '@/components/Konumlar.vue'
import JQuery from 'jquery';
import {arrayFindIndex} from "element-ui/src/utils/util";

let $ = JQuery;

var moment = require('moment');
let time = moment().format('YYYY-MM-DD HH:mm:ss');

export default {
  name: "MusteriTanimla",
  components: {
    Resim,
    Seo,
    Konumlar
  },
  watch: {
    imageList: function (val) {
      if (val.length === 1) {
        this.musteriForm.resimKonum = "1";
        this.musteriForm.galeriKonum = "0";
      } else if (val.length > 1) {
        this.musteriForm.galeriKonum = "1";
      } else {
        this.musteriForm.resimKonum = "0";
        this.musteriForm.galeriKonum = "0";
      }
    },
  },
  computed: {
    imageList() {
      return this.musteriForm.resim
    }
  },
  mounted() {
    const self = this
    EventBus.$on("onPersonalImage", function (bool, lastPushImage, allImage) {
      if (bool) {
        self.musteriForm.logo = lastPushImage;
      }
    });
  },
  data() {
    return {
      selectedImages: [],
      totalKategori: 0, // kategorilerin sayısını ilk önce cekerek kategori listesini komple cekmek için
      catLoading: false,
      kategoriListe: [],
      ekstralar: [{}],
      secili: false,
      loading: false,
      selectedImagesFromServer: [],
      path: musteriService.path,
      imagePath: musteriService.imagePath,
      belgePath: musteriService.belgePath,
      imageListMain: [],
      videoVis: false,
      editor: ClassicEditor,
      editorConfig: {
        language: 'tr',
      },
      activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', "11"],
      visibleSil: false,
      disabled: false,
      musteriForm: {
        logo: [],
        not: '',
        unvan: '',
        telefon: '',
        eposta: '',
        adres: 'OSB',
        website: '',
        musteriAdi: '',
        vergiNo: '',
        vergiDairesi: '',
        durum: '1',
      },
      rulesMusteri: {
        musteriAdi: [{
          required: true,
          message: "Lütfen Firma Adı Giriniz",
          trigger: 'blur'
        }],
      },
    }
  },
  methods: {
    arrayFindIndex,
    addNewInfo() {
      this.ekstralar.push({telefon: '', eposta: '', adSoyad: '', unvan: ''});
    },
    subInfo(index) {
      this.ekstralar.splice(index, 1);
      if (this.secili && this.ekstralar.length == 0) {
        this.addNewInfo()
      }
    },
    imageUpload(file) {
      this.imageListMain = []
      this.musteriForm.resim = []
      if ((file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') && this.imageListMain.length < 2) {
        var item = {
          name: file.name,
          url: file.url,
          id: file.raw.lastModified,
          size: file.raw.size
        };
        this.imageListMain.push(item)

        file.raw["tmp_name"] = file.url; // backend file_url'i tmp_name değişkeninden alıyor

        this.musteriForm.resim.push(file.raw)
        $('#musteriekle-resim .el-upload--picture-card').hide();
      }
    },
    imageRemove() {
      $('#musteriekle-resim .el-upload--picture-card').show();
      this.imageListMain = [];
      this.musteriForm.resim = [];
    },
    musteriEkle(formName) {
      this.$refs[formName].validate((valid, errors) => {
        if (valid) {
          this.$confirm("Müşteriyi tanımlamak istediğinize emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
            confirmButtonText: this.$t("src.views.apps.genel.yes"),
            cancelButtonText: this.$t("src.views.apps.genel.no"),
            type: 'warning'
          }).then(() => {
            this.loading = true;
            musteriService.musteriEkle(this.musteriForm, this.ekstralar).then((response) => {
              if (response.status == 200) {
                localStorage.setItem("userDataDemirag", response.token)
                notification.Status("success", this, response.msg)
                EventBus.$emit("musterilistesi", this.musteriForm.durum)
                functions.sayfaKapat("yatirimcitanimla", this);
                this.resetForm(formName)
              }
              this.loading = false;
            }).catch(err => {
              if (err.responseJSON) {
                let error = err.responseJSON
                if (error.status == 401) {
                  notification.Status(150, this);
                } else notification.Status("errorMsg", this, error.errMsg)
              } else {
                //notification.Status(503, this)
              }
              this.loading = false;
            })
          }).catch((e) => {
          })
        } else {
          for (var k in errors) {
            errors[k].forEach((element) => {
              notification.Status("warning", this, element.message);
            })
            this.loading = false
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visibleSil = false;
    },
  }
}

</script>

<style scoped>
.el-form-item__error {
  color: #dc0000ad !important;
  margin: 3px 0 0 0;
  position: relative;
  font-size: 0.755rem !important;
}
</style>
